module.exports = __webpack_public_path__ + "assets/120ca0520fe31f402b6dccf4bf4c931e.svg";